/**
 * OVERRIDE More.jsx
 */

import More from '../../../../components/Toolbar/More';

export default More;